export const formatNumber = (value: number | string): string => {
  const number = Number(value);

  if (isNaN(number)) return String(value);

  return number.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

// Credits are unitless integer counters (not money) — no currency symbol, no
// decimals. Use for every credit display so the formatting stays consistent.
export const formatCredit = (value: number | string): string => {
  const number = Number(value);

  if (isNaN(number)) return String(value);

  return Math.round(number).toLocaleString("en-US", {
    maximumFractionDigits: 0,
  });
};

/**
 * Safely converts a string to a number, returning 0 if the conversion fails.
 *
 * @param {string} value - The input string to convert.
 * @returns {number} The converted number or 0 if invalid.
 */
export const safeStringToNumber = (value: string): number | string => {
  const num = parseFloat(value);
  return isNaN(num) ? "" : num;
};

export const toNumber = (value: string): number => {
  const num = parseFloat(value);
  return isNaN(num) ? 0 : num;
};

export const toNumberOrNull = (value: string): number | null => {
  if (value === "" || value === null || value === undefined) return null;
  const num = parseFloat(value);
  return isNaN(num) ? null : num;
};

/**
 * Formats date to local timezone using native browser methods
 */
export const formatDateTimeLocal = (
  date: Date | string | number,
  separator = " ",
  // Opt-in: seconds matter where a moment is being pinned down (a coupon's
  // creation time), not in a list where they would only add noise.
  withSeconds = false
): string => {
  const localDate =
    typeof date === "string" || typeof date === "number"
      ? new Date(date)
      : date;

  const dateStr = localDate.toLocaleDateString("en-GB"); // dd/mm/yyyy format
  const timeStr = localDate.toLocaleTimeString("en-GB", {
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
    ...(withSeconds ? { second: "2-digit" as const } : {}),
  });

  return `${dateStr}${separator}${timeStr}`;
};
